'use client';

import Button from '@/components/ui/Button';
import SectionTitle from '@/components/ui/SectionTitle';
import Link from 'next/link';

export default function ComingSoonClient() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center relative overflow-hidden">
      <style jsx global>{`
        #global-contact-form { display: none !important; }
      `}</style>
      {/* Background decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Diagonal lines similar to hero sections */}
        <div className="w-full origin-center transform-gpu absolute -left-[40%] top-0 opacity-10">
          <div className="h-[1px] bg-gray-300 rotate-[296.7deg] w-[200%]" />
        </div>
        <div className="w-full origin-center transform-gpu absolute -right-[40%] top-0 opacity-10">
          <div className="h-[1px] bg-gray-300 rotate-[296.8deg] w-[200%]" />
        </div>

        {/* Decorative shapes */}
        <div className="absolute top-20 left-10 opacity-20">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="35" stroke="#272D57" strokeWidth="2" fill="none" />
            <circle cx="40" cy="40" r="25" stroke="#D53333" strokeWidth="1" fill="none" />
          </svg>
        </div>

        <div className="absolute bottom-20 right-10 opacity-20">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="10" width="40" height="40" stroke="#272D57" strokeWidth="2" fill="none" transform="rotate(45 30 30)" />
            <rect x="15" y="15" width="30" height="30" stroke="#D53333" strokeWidth="1" fill="none" transform="rotate(45 30 30)" />
          </svg>
        </div>

        <div className="absolute top-1/2 right-20 opacity-20">
          <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 50 L50 20 L80 50 L50 80 Z" stroke="#272D57" strokeWidth="2" fill="none" />
            <path d="M30 50 L50 30 L70 50 L50 70 Z" stroke="#D53333" strokeWidth="1" fill="none" />
          </svg>
        </div>
      </div>

      <div className="custom-container mx-auto px-4 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          {/* Coming Soon Text */}
          <div className="mb-8">
            <h1 className="text-6xl lg:text-[8rem] font-bold text-[#272d57] leading-none tracking-tighter">
              Coming Soon
            </h1>
          </div>

          {/* Section Title */}
          <div className="mb-12">
            <SectionTitle
              title="We're Building Something Amazing"
              description=""
              align="center"
              titleMaxWidth="3xl"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Link href="/">
              <Button
                variant="primary"
                responsiveSize={{
                  mobile: 'lg',
                  desktop: 'xl'
                }}
                className="min-w-[200px]"
              >
                Go Home
              </Button>
            </Link>

            <Link href="/contact-us">
              <Button
                variant="secondary"
                responsiveSize={{
                  mobile: 'lg',
                  desktop: 'xl'
                }}
                className="min-w-[200px]"
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom decorative element */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-50 to-transparent opacity-50" />
    </div>
  );
}

